import { render, staticRenderFns } from "./addRevation.vue?vue&type=template&id=fd86b92c"
import script from "./addRevation.vue?vue&type=script&lang=js"
export * from "./addRevation.vue?vue&type=script&lang=js"
import style0 from "./addRevation.vue?vue&type=style&index=0&id=fd86b92c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports